import type { CSSProperties, ReactNode } from "react";
import type { ResolvedThemeValues } from "@shared-core/data/customer-api-types";
import { cn } from "../../../app/components/primitives/utils";
import { portalThemeCssVariables } from "./portalThemeCssVariables";

/**
 * Applies a resolved portal theme to everything inside it, as design-token variables on this element. With no theme
 * (the read failed, or the feature is off) it sets nothing, and `theme.css` is the Pollards look. Used by the portal
 * chrome and by the staff editor's live preview, so both render the same way.
 */
export function ThemedSurface({
  theme,
  className,
  children,
}: {
  theme: ResolvedThemeValues | null;
  className?: string;
  children: ReactNode;
}) {
  const style = theme
    ? (portalThemeCssVariables(theme) as CSSProperties)
    : undefined;
  return (
    <div
      style={style}
      className={cn("bg-background text-foreground", className)}
    >
      {children}
    </div>
  );
}
